<script>
import MicroModal from "micromodal";

export default {
  name: "Videosection",

  mounted() {
    MicroModal.init({
      onClose: modal => {
        document.querySelector('#modal-1 iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    });
  }
};
</script>

<template>
  <div class="row">
    <div class="container">
      <section class="section">
        <div class="text-authenticity">
          <h2>
            #Digitalizesua<span>campanha</span>
          </h2>
          <p>
            Acreditamos que realizar sua campanha de financiamento coletivo vai muito além de tecnologia, envolve planejamento e estratégias. Por isso, oferecemos a todos que estão no Voto Legal uma mentoria exclusiva. Veja como funciona nesse vídeo.
          </p>
          <button data-micromodal-trigger="modal-1">
            Assista o vídeo
          </button>
        </div>
      </section>
    </div>

    <div
      id="modal-1"
      class="modal micromodal-slide"
      aria-hidden="true"
    >
      <div
        class="modal__overlay"
        tabindex="-1"
        data-micromodal-close
      >
        <div
          class="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-1-title"
        >
          <header class="modal__header">
            <button
              class="modal__close"
              aria-label="Close modal"
              data-micromodal-close
            />
          </header>
          <main
            id="modal-1-content"
            class="modal__content"
          >
            <iframe
              src="https://www.youtube.com/embed/CxFtSQ-6C_A?rel=0&enablejsapi=1"
              width="600"
              height="400"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.row {
  background-color: #0aba7e;
  background-image: url("../../img/video-bg.svg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.text-authenticity {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.text-authenticity button {
  display: flex;
  align-items: center;
  max-width: 200px;
  border-radius: 8px;
  background-color: #336666;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  border: 0;
  color: #fff;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  font-family: 'Miriam Libre', sans-serif;

  &:before {
    content: "\25BA";
    display: inline-block;
    margin-right: 5px;
    font-size: 1.5rem;
    vertical-align: middle;
  }
}

h2 {
  text-align: center;
  color: #2e656f;
  margin-bottom: 2rem;

  @media (max-width: 480px) {
    font-size: 28px;
  }

  @media (max-width: 400px) {
    font-size: 25px;
  }

}

h2 span {
  color: #fff;
}

.text-authenticity p {
  max-width: 39.5rem;
  font-size: 16px;
  line-height: 2;
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;

  @media (min-width: 480px) {
    font-size: 18px;
  }
}

.modal iframe {
  max-width: 100%;
}


/**************************\
  Basic Modal Styles
\**************************/

.modal {
  font-family: -apple-system,BlinkMacSystemFont,avenir next,avenir,helvetica neue,helvetica,ubuntu,roboto,noto,segoe ui,arial,sans-serif;
}

.modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.modal__container {
  background-color: #fff;
  padding: 10px;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
}

.modal__header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.modal__title {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.25;
  color: #00449e;
  box-sizing: border-box;
}

.modal__close {
  background: transparent;
  border: 0;
}

.modal__header .modal__close:before { content: "\2715"; }

.modal__content {
  margin-top: 0.5rem;
  line-height: 1.5;
  color: rgba(0,0,0,.8);
}

.modal__btn {
  font-size: .875rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  background-color: #e6e6e6;
  color: rgba(0,0,0,.8);
  border-radius: .25rem;
  border-style: none;
  border-width: 0;
  cursor: pointer;
  -webkit-appearance: button;
  text-transform: none;
  overflow: visible;
  line-height: 1.15;
  margin: 0;
  will-change: transform;
  -moz-osx-font-smoothing: grayscale;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  transition: -webkit-transform .25s ease-out;
  transition: transform .25s ease-out;
  transition: transform .25s ease-out,-webkit-transform .25s ease-out;
}

.modal__btn:focus, .modal__btn:hover {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}

.modal__btn-primary {
  background-color: #00449e;
  color: #fff;
}



/**************************\
  Demo Animation Style
\**************************/
@keyframes mmfadeIn {
    from { opacity: 0; }
      to { opacity: 1; }
}

@keyframes mmfadeOut {
    from { opacity: 1; }
      to { opacity: 0; }
}

@keyframes mmslideIn {
  from { transform: translateY(15%); }
    to { transform: translateY(0); }
}

@keyframes mmslideOut {
    from { transform: translateY(0); }
    to { transform: translateY(-10%); }
}

.micromodal-slide {
  display: none;
}

.micromodal-slide.is-open {
  display: block;
}

.micromodal-slide[aria-hidden="false"] .modal__overlay {
  animation: mmfadeIn .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="false"] .modal__container {
  animation: mmslideIn .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__overlay {
  animation: mmfadeOut .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="true"] .modal__container {
  animation: mmslideOut .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide .modal__container,
.micromodal-slide .modal__overlay {
  will-change: transform;
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/videosection.vue